import { cn } from '@bem-react/classname';

export const cnSpin = cn('Spin2');
